module.exports = __webpack_public_path__ + "img/1390b12.jpg";